
import React from 'react';
import { PlayIcon, PauseIcon } from '../icons/NavigationIcons';
import TimerControlButton from './TimerControlButton';

interface PlayPauseButtonProps {
  isRunning: boolean;
  onToggle: () => void;
  isMobile: boolean;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  isRunning,
  onToggle,
  isMobile
}) => {
  const handleClick = (e: React.MouseEvent) => {
    // Prevent event bubbling
    e.stopPropagation();
    console.log(`PlayPauseButton: clicked - current state: ${isRunning ? 'running' : 'paused'}`);
    onToggle();
  };

  return (
    <TimerControlButton 
      onClick={handleClick}
      size="large"
      ariaLabel={isRunning ? "Pause" : "Play"}
    >
      {isRunning ? <PauseIcon size={isMobile ? 24 : 28} /> : <PlayIcon size={isMobile ? 24 : 28} />}
    </TimerControlButton>
  );
};

export default PlayPauseButton;
